<div class="modal fixed-left" [ngClass]="show ? 'index show' : ''">
  <div class="modal-dialog modal-dialog-aside">
    <div class="modal-content">
      <div class="side-modal-body">
        <mat-icon (click)="onClose()">close</mat-icon>
        <mat-card>
          <div class="content-section" [formGroup]="planPhasesForm">
            <div class="form-title">
              <h2>{{ phasesActionType === 'add' ? 'Add' : 'Edit'}} plan phases</h2>
            </div>
            <mat-horizontal-stepper #stepper labelPosition="top">
              <mat-step>
                <ng-template matStepLabel> Free trial phase </ng-template>

                <!-- Free trial phase section -->
                <div class="publish-section" formGroupName="freeTrail">
                  <div class="sub-title">Free trial phase</div>
                  <p>The free trial phase starts right after the customer purchases the plan. The
                    billing
                  period won't apply to the free trial phase.</p>

                  <mat-radio-group formControlName="type" (change)="onTypeChange($event)">
                    <mat-radio-button value="TRIAL_PHASE">Offer free trial</mat-radio-button>
                    <mat-radio-button value="skipTrail">Skip free trial</mat-radio-button>
                  </mat-radio-group>

                  @if (trailPhaseType.value === 'TRIAL_PHASE') {
                    <div class="duration-section"
                      formGroupName="duration">
                      <div class="form-section">
                        <mat-form-field class="duration-field">
                          <mat-label>Duration</mat-label>
                          <input type="number" matInput required formControlName="count" />
                        </mat-form-field>
                        <mat-form-field class="unit-field">
                          <mat-select required value="MONTH" formControlName="unit">
                            <mat-option value="DAY">Day(s)</mat-option>
                            <mat-option value="MONTH">Month(s)</mat-option>
                            <mat-option value="QUARTER">Quarter(s)</mat-option>
                            <mat-option value="YEAR">Year(s)</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  }

                  @if (phasesActionType === 'add') {
                    <div class="action-btn-section">
                      <button mat-flat-button color="primary" class="upload-btn"
                        [disabled]="trailPhaseForm.invalid"
                      (click)="continue()">Continue</button>
                    </div>
                  }

                  @if (phasesActionType !== 'add') {
                    <div class="action-btn-section">
                      <button mat-flat-button color="primary" class="upload-btn"
                        [disabled]="!formChanged || planPhasesForm.invalid"
                      (click)="updateChanges()">Update</button>
                      <button mat-button [disabled]="!formChanged"
                      (click)="discardChanges()">Discard</button>
                    </div>
                  }
                </div>

              </mat-step>
              <mat-step>
                <ng-template matStepLabel> Discount phase </ng-template>

                <!-- Discount phase section -->
                <div class="publish-section" formGroupName="discount">
                  <div class="sub-title">Discount phase</div>
                  <p>Discount phase starts after the free trial phase is complete.</p>

                  <mat-radio-group formControlName="type" (change)="onTypeChange($event)">
                    <mat-radio-button value="DISCOUNT_PHASE">Offer discount</mat-radio-button>
                    <mat-radio-button value="skipDiscount">Skip discount</mat-radio-button>
                  </mat-radio-group>

                  @if (discountPhaseType.value === 'DISCOUNT_PHASE') {
                    <div>
                      <div class="duration-section" formGroupName="duration">
                        <div class="sub-title">Duration</div>
                        <div class="form-section">
                          <mat-form-field class="duration-field">
                            <mat-label>Duration</mat-label>
                            <input type="number" matInput required formControlName="count" />
                          </mat-form-field>
                          <mat-form-field class="unit-field">
                            <mat-select required value="MONTH" formControlName="unit">
                              <mat-option value="DAY">Day(s)</mat-option>
                              <mat-option value="MONTH">Month(s)</mat-option>
                              <mat-option value="QUARTER">Quarter(s)</mat-option>
                              <mat-option value="YEAR">Year(s)</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="price-section">
                        <div class="sub-title">Discount phase price</div>
                        <p>Enter the discount phase price in different currencies. You can go to the
                          Product information page to change the product's supported currencies.
                        </p>
                        <div class="form-section">
                          <ng-container [FormArray]="recurringDiscountPriceFormArray">
                            @for (priceForm of recurringDiscountPriceFormArray.controls; track priceForm; let i = $index) {
                              <div class="field-section" [formGroup]="priceForm">
                                <mat-form-field class="duration-field">
                                  <mat-label>Price</mat-label>
                                  <input type="number" matInput required
                                    formControlName="price" />
                                  <span matSuffix
                                    class="currency-suffix">{{recurringDiscountPriceFormArray.value[i].currency}}
                                  / {{showBillingPeriod(rootFormGroup.value.billingPeriod)}}</span>
                                </mat-form-field>
                              </div>
                            }
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  }

                  @if (phasesActionType === 'add') {
                    <div class="action-btn-section">
                      <button mat-flat-button color="primary" class="upload-btn"
                        [disabled]="discountForm.invalid"
                      (click)="continue()">Continue</button>
                      <button mat-button (click)="previous()">Previous Step</button>
                    </div>
                  }

                  @if (phasesActionType !== 'add') {
                    <div class="action-btn-section">
                      <button mat-flat-button color="primary" class="upload-btn"
                        [disabled]="!formChanged || planPhasesForm.invalid"
                      (click)="updateChanges()">Update</button>
                      <button mat-button [disabled]="!formChanged"
                      (click)="discardChanges()">Discard</button>
                    </div>
                  }
                </div>
              </mat-step>
              <mat-step>
                <ng-template matStepLabel> Regular phase </ng-template>

                <!-- Regular phase section -->
                <div class="publish-section" formGroupName="regular">
                  <div class="sub-title">Regular phase</div>
                  <p>The regular phase starts after the free trial and discount phases are complete,
                    and
                  the charge recurs every billing period.</p>

                  <mat-radio-group (change)="onRegularPhaseFormSlection($event)"
                    formControlName="type">
                    <mat-radio-button value="UNLIMITED_PHASE">Unlimited term</mat-radio-button>
                    <mat-radio-button value="FIXED_PHASE">Fixed term</mat-radio-button>
                  </mat-radio-group>

                  @if (regularPhaseType.value === 'FIXED_PHASE') {
                    <div class="duration-section"
                      formGroupName="duration">
                      <div class="sub-title">Duration</div>
                      <div class="form-section">
                        <mat-form-field class="duration-field">
                          <mat-label>Duration</mat-label>
                          <input type="number" matInput required formControlName="count" />
                        </mat-form-field>
                        <mat-form-field class="unit-field">
                          <mat-select required value="MONTH"
                            formControlName="unit">
                            <mat-option value="DAY">Day(s)</mat-option>
                            <mat-option value="MONTH">Month(s)</mat-option>
                            <mat-option value="QUARTER">Quarter(s)</mat-option>
                            <mat-option value="YEAR">Year(s)</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  }

                  <div class="price-section">
                    <div class="sub-title">Regular phase price</div>
                    <p>Enter the regular phase price in different currencies. You can go to the
                      Product
                    information page to change the product's supported currencies.</p>
                    <div class="form-section">
                      <ng-container formArrayName="recurringRegularPriceFormArray">
                        @for (priceForm of recurringRegularPriceFormArray.controls; track priceForm; let i = $index) {
                          <div class="field-section" [formGroup]="priceForm">
                            <mat-form-field class="duration-field">
                              <mat-label>Price</mat-label>
                              <input type="number" matInput required
                                formControlName="price" />
                              <span matSuffix
                                class="currency-suffix">{{recurringRegularPriceFormArray.value[i].currency}}
                              /  {{showBillingPeriod(rootFormGroup.value.billingPeriod)}}</span>
                            </mat-form-field>
                          </div>
                        }
                      </ng-container>
                    </div>
                  </div>

                  @if (phasesActionType === 'add') {
                    <div class="action-btn-section">
                      <button mat-flat-button color="primary" class="upload-btn"
                      [disabled]="!formChanged || planPhasesForm.invalid" (click)="saveChanges()">Save</button>
                      <button mat-button (click)="previous()">Previous Step</button>
                    </div>
                  }

                  @if (phasesActionType !== 'add') {
                    <div class="action-btn-section">
                      <button mat-flat-button color="primary" class="upload-btn"
                        [disabled]="!formChanged || planPhasesForm.invalid"
                      (click)="updateChanges()">Update</button>
                      <button mat-button [disabled]="!formChanged"
                      (click)="discardChanges()">Discard</button>
                    </div>
                  }
                </div>
              </mat-step>
            </mat-horizontal-stepper>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop fade" [ngClass]="show ? 'index show' : ''"></div>

<ng-template #exitConsentDialog>
  <h2 mat-dialog-title>Discard Changes?</h2>
  <div mat-dialog-content>
    You have unsaved changes. Would you like to discard the changes before navigating away from the page?
  </div>
  <div mat-dialog-actions class="action-btn">
    <button mat-button class="next-btn" mat-dialog-close>Continue Editing</button>
    <button mat-button class="next-btn" (click)="onDiscardEditing()">Discard Changes</button>
  </div>
</ng-template>